
// Profile Photo sidebar Style
export const ProfilePicStyle = {
    maxWidth: "120px",
    maxHeight: "120px",
   borderRadius: "50%",
   display: "block",
   margin: "20px 10px",
   border: "1.5px solid var(--orange)",
 };

 //first name style in victim details profile
 export const FstNameStyle = {
   paddingRight:'5px',
   marginLeft:'10px',
 }
// sidebar headline style
export const headlineStyle = {
    // paddingRight:'5px',
    marginLeft:'10px',
    marginRight:'10px',
    fontWeight:'600',
    color:'var(--black)',
    textTransform:'uppercase'
  }

   export const subTextStyle = {
    marginLeft:'10px',
    marginBottom:'0',
    paddingBottom:"0",
    fontWeight:'500',
    color:'var(--darkGray)',
  }